import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ew-main-loader',
  templateUrl: './ew-main-loader.component.html',
  styleUrls: ['./ew-main-loader.component.css']
})
export class EwMainLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
